import { Box, Button, Flex, Icon, Link, Spacer } from "@chakra-ui/react";
import { ArrowRightIcon } from "@phosphor-icons/react/dist/ssr";
import { LazyLoadComponent } from "react-lazy-load-image-component";

import { brandColor } from "@/utilities/color-presets/colorConfig";
import { wrapBgImage } from "@/utilities/helpers/wrapBgImage";

function GuiaCardSecondHomes(props) {
    const { id, title, subTitle, buttonText, link, imageUrl, referred } = props;

    const redirectNewPage = () => {
        if (referred) {
            window.open(link, "_blank");
        }
    };

    return (
        <LazyLoadComponent id={id}>
            <Box
                display="flex"
                w="330px"
                boxShadow="rgb(221, 221, 221) 0px 4px 8px 0px"
                onClick={() => redirectNewPage()}
                h="420px"
                as="div"
                transitionDuration="0.2s"
                transitionTimingFunction="linear"
                transform="scale(1)"
                mt={{ base: "0", md: "25px" }}
                borderRadius="10px"
                bgImage={wrapBgImage(imageUrl)}
                bgSize="cover"
                bgRepeat="no-repeat"
                backgroundPosition="center"
            >
                <Flex direction="column" w="100%">
                    <Spacer />
                    <Flex direction="column" w="full">
                        <Box borderBottomRadius="10px" paddingTop="1" bg="white" textAlign="center">
                            <Link
                                _hover={{
                                    textDecoration: "none",
                                    ...brandColor,
                                }}
                                fontWeight="semibold"
                                textTransform="uppercase"
                                fontSize="md"
                                letterSpacing="wide"
                                color="#000"
                                external
                            >
                                {title}
                            </Link>
                            <Link
                                _hover={{
                                    textDecoration: "none",
                                    ...brandColor,
                                }}
                                my={1}
                                display="block"
                                fontSize="md"
                                lineHeight="normal"
                                color="#000"
                                external
                            >
                                {subTitle}
                            </Link>
                            <Box justifyContent="center">
                                <Button
                                    border="none"
                                    fontWeight="normal"
                                    color="#317FDA"
                                    size="sm"
                                    maxWidth="100px"
                                    bg="transparent"
                                    my={2}
                                    _hover={{ bg: "transparent" }}
                                >
                                    {buttonText}
                                    <Icon color="black" fill="#000">
                                        <ArrowRightIcon />
                                    </Icon>
                                </Button>
                            </Box>
                        </Box>
                    </Flex>
                </Flex>
            </Box>
        </LazyLoadComponent>
    );
}

export default GuiaCardSecondHomes;
